import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AutorizadoresService {

  autorizadoresGet$ = new BehaviorSubject(null);
  autorizadoresGetProc$ = new BehaviorSubject(null);
  autorizadoresPost$ = new BehaviorSubject(null);
  autorizadoresPut$ = new BehaviorSubject(null);
  autorizadoresDelete$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  //Buscar Autorizadores
  get(id_cliente) {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Autorizador/grid_lista_de_autorizadores_cliente/" + id_cliente + "/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.autorizadoresGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.autorizadoresGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.autorizadoresGet$.unsubscribe(),
          this.autorizadoresGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Buscar Procuradores
  getProc(id_cliente) {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Autorizador/ObterProcuradores/" + id_cliente + "/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.autorizadoresGetProc$.next(data),
        error: (error: HttpErrorResponse) => {
          this.autorizadoresGetProc$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.autorizadoresGetProc$.unsubscribe(),
          this.autorizadoresGetProc$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Incluir Autorizador
  post(autorizador: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Autorizador/Incluir"
      autorizador.empresa = environment.empresa;

      this.http.post(url, autorizador, { headers: headers })
        .subscribe({
          next: (res: any) => this.autorizadoresPost$.next(res),
          error: (error: HttpErrorResponse) => {
            this.autorizadoresPost$.next(false);
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.autorizadoresPost$.unsubscribe(),
            this.autorizadoresPost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Alterar Autorizador
  put(autorizador: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      autorizador.empresa = environment.empresa;

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Autorizador/Editar";

      this.http.put(url, autorizador, { headers: headers })
        .subscribe({
          next: (res: any) => this.autorizadoresPut$.next(res),
          error: (error: HttpErrorResponse) => {
            this.autorizadoresPut$.next(false);
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.autorizadoresPut$.unsubscribe(),
            this.autorizadoresPut$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Deletar Autorizador
  del(autorizador: any) {
    try {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: autorizador
      };

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Autorizador/Excluir";
      autorizador.empresa = environment.empresa;

      this.http.delete(url, options).subscribe({
        next: (res: any) => this.autorizadoresDelete$.next(res),
        error: (error: HttpErrorResponse) => {
          this.autorizadoresDelete$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.autorizadoresDelete$.unsubscribe(),
          this.autorizadoresDelete$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}
